/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CognitoUser } from '../models/CognitoUser';
import type { CognitoUserData } from '../models/CognitoUserData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthenticationService {

    /**
     * SignIn with Email API Endpoint
     * Sign In with Email through Cognito
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static signIn(
requestBody: {
email: string;
password: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: CognitoUserData;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user/auth/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                406: `Not Acceptable`,
            },
        });
    }

    /**
     * Get Google Cognito User API Endpoint
     * Get User Data through Google Login
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static getuser(
requestBody: {
accessToken: string;
userType?: number;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: {
UserData?: CognitoUser;
};
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * SignUp API Endpoint
     * Create user to cognito
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static signUp(
requestBody: {
email: string;
password: string;
userType: number;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: {
UserConfirmed?: boolean;
UserSub?: string;
CodeDeliveryDetails?: {
AttributeName?: string;
DeliveryMedium?: string;
Destination?: string;
};
};
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user/auth/signup',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Verify API Endpoint
     * Verify User through Cognito
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static verify(
requestBody: {
email: string;
verificationCode: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: any;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user/auth/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Resend Confirmation Code API Endpoint
     * Resend Confirmation Code through Email
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static resend(
requestBody: {
email: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: any;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user/auth/resend',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Internal Server error`,
            },
        });
    }

    /**
     * Request Reset Password API Endpoint
     * Request Reset Password through Email
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static requestResetPassword(
requestBody: {
email: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: any;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user/auth/request_reset_password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Reset Password API Endpoint
     * Reset Password
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static resetPassword(
requestBody: {
email: string;
confirmationCode: string;
password: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: any;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user/auth/reset_password',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Change Password API Endpoint
     * Change Password
     * @param xAccessToken 
     * @param requestBody 
     * @returns any successful operation
     * @throws ApiError
     */
    public static changePassword(
xAccessToken: string,
requestBody: {
oldPassword: string;
newPassword: string;
},
): CancelablePromise<{
status?: number;
message?: string;
data?: any;
}> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/user/change_password',
            headers: {
                'x-access-token': xAccessToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

}
